import React from "react";

const { PulseLoader } = require("halogenium");

export default function PulseLoading() {
  return <PulseLoader color="black" size='16px' margin='4px' />;
}